var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"present"},[_vm._m(0),_vm._l((_vm.list),function(item,i){return _c('div',{key:i,staticClass:"present-zt",style:({
      backgroundImage: _vm.nuber == i ? `url(${_vm.images})` : `url(${_vm.image})`,
    }),on:{"click":function($event){return _vm.website(i)}}},[_c('p',{staticClass:"span"},[_vm._v(_vm._s(item.name))])])})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"present-arrows"},[_c('img',{attrs:{"src":require("../assets/arrows.png"),"alt":""}})])
}]

export { render, staticRenderFns }